import { z } from 'zod';

const serviceEntrySchema = z.object({
  key: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
  icon: z.string().min(1),
  status: z.enum(['live', 'coming_soon', 'in_the_works']),
  href: z.string().min(1).nullable(),
  ctaLabel: z.string().min(1).nullable(),
});

export const servicesSchema = z
  .array(serviceEntrySchema)
  .refine((list) => list.filter((s) => s.status === 'live').length >= 1, {
    message: 'at least one service must be status: live',
  });

export type Service = z.infer<typeof serviceEntrySchema>;
